export const usersMock = [
  {
    id: 'd9f87740-b8e9-41a9-9177-42efbe2c14ed',
    userName: 'Aura Mayorga',
    userAvatar: '',
    roleName: 'Sales Development Representative ',
    ouName: 'Sales',
  },
  {
    id: '1265bab7-fdd3-4d4c-b75b-b0d875838a8e',
    userName: 'Aydee Quispe',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1653429346/Courses/yyr3rnbrbz0qb1roooyb.jpg',
    roleName: 'Software Engineer',
    ouName: 'Engineering',
  },
  {
    id: 'edcce48d-8391-49e1-add2-e9952e8c54d9',
    userName: 'Ayelen Criscuolo',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Software Engineer',
    ouName: '',
  },
  {
    id: '8bfcae6c-8b9e-44f0-a256-ca92d0fb1379',
    userName: 'Bárbara Briceño',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1669153130/Courses/mbhrkjrca9rrr2ifmy79.jpg',
    roleName: 'Sr. Instructional Designer',
    ouName: 'Operations',
  },
  {
    id: 'c02986f5-1db8-4d2d-a6d1-89c831ecf313',
    userName: 'Blabla prueba',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Accounts Receivable Representative',
    ouName: 'Atención al Cliente',
  },
  {
    id: '4a5fb688-0148-4be7-b7cc-2c3523f1a0bc',
    userName: 'Blas Farias',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1680738941/Courses/cw6zcobljunb1pv6rtp2.png',
    roleName: 'Data Analyst',
    ouName: 'Data ',
  },
  {
    id: 'e1c59110-2739-4f63-b6ba-d6fee1415e57',
    userName: 'Brayan Uriel Santos Torres',
    userAvatar: '',
    roleName: 'Jr. Post Production Editor ',
    ouName: 'Creative Product Content ',
  },
  {
    id: 'be8a9730-4f40-4554-8a84-88026345528d',
    userName: 'Bryan Vázquez',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Software Engineer',
    ouName: 'Engineering',
  },
  {
    id: 'f777012b-31d9-4d0b-94ce-144a91327fb2',
    userName: 'Bryan Key',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1666371382/Courses/n2jfbo6svb98xgkrasae.jpg',
    roleName: 'Software Engineer',
    ouName: 'Engineering',
  },
  {
    id: '3eeeb801-c669-4a71-9a12-4fa6058feb6d',
    userName: 'Bryan Exp3',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Usuario Externo',
    ouName: '',
  },
  {
    id: '8c6c6716-8728-40ff-a009-73368221ac7b',
    userName: 'Carlos Martinez',
    userAvatar: '',
    roleName: 'general',
    ouName: 'general',
  },
  {
    id: 'e9edf144-5637-4788-8065-7f3861459457',
    userName: 'Carlos Silva',
    userAvatar: '',
    roleName: 'Head of Human Resources',
    ouName: 'General Administration',
  },
  {
    id: 'cc40fbd5-1303-4032-ab7f-71a4df0dfddd',
    userName: 'Carlos Saavedra Saavedra',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1675866337/Courses/ckspwznkibb9nca9hkuk.jpg',
    roleName: 'Sr. Instructional Designer',
    ouName: 'Operations',
  },
  {
    id: 'c041ab6d-9b47-42e0-b097-a8cd1f3a5836',
    userName: 'Carolina De La Garza',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1632235345/Courses/tcqk1d3rzpaqy0s5veey.jpg',
    roleName: 'Project Manager',
    ouName: 'Creative Product Content ',
  },
  {
    id: '911a91b8-c20f-47fe-8d81-5b4a43646eb2',
    userName: 'Cecilia González Martínez',
    userAvatar: '',
    roleName: 'Freelance',
    ouName: 'Creative Product Content ',
  },
  {
    id: '646ae9cf-3ba4-4567-aace-315911130362',
    userName: 'Cesar Ricarte',
    userAvatar: '',
    roleName: 'CEO',
    ouName: 'General Administration',
  },
  {
    id: '654f8d79-b328-4249-85c9-77a70b0a53a3',
    userName: 'Chris Courses Block',
    userAvatar:
      'https://firebasestorage.googleapis.com/v0/b/lernit-dev-79de5.appspot.com/o/voldemort%2Fusers%2Fprofiles%2F1716218637947.png?alt=media&token=c6d54db6-d882-4974-a966-bf852db0ac8e',
    roleName: 'Participante',
    ouName: 'Participantes',
  },
  {
    id: '076ce9f3-e8d1-4f7a-941f-1988a0ea657a',
    userName: 'Christian David Leon Jimenez',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1707169358/Courses/phvbo9lf7an3w1pzwez9.jpg',
    roleName: 'Software Engineer',
    ouName: 'Digital Academy Squad',
  },
  {
    id: '04e49daa-00ae-48fb-9a59-44aa9b08e86e',
    userName: 'claims claism',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Administracion',
  },
  {
    id: '65541342-f864-407d-b41d-6805d33eaff5',
    userName: 'Claims Test Claims Test',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Administración',
  },
  {
    id: '0d2bcff1-52f3-4a9f-ba2a-83f2c4807649',
    userName: 'Copia 1 Copia 1',
    userAvatar: '',
    roleName: 'ROL DE PRUEBA',
    ouName: 'Engineering',
  },
  {
    id: 'b337d6eb-12d9-4011-8a10-3d51a6adb037',
    userName: 'Cristel Flores',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1666821364/Courses/w35h5xndifwzsszslud0.png',
    roleName: 'Post Production Editor',
    ouName: 'Creative Product Content ',
  },
  {
    id: '29085e70-9d89-4b2c-a89e-4f300b3c94ae',
    userName: 'Cristina Luna',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1664984662/Courses/jawt8zor4cidqeo8hvaq.jpg',
    roleName: 'Graphic Designer',
    ouName: 'Creative Product Content ',
  },
  {
    id: '83233373-3596-4315-b7c0-b571a71454a7',
    userName: 'Daniel Sandoval',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1648081581/Courses/t6s6hxmobtr3hmlmuldq.jpg',
    roleName: 'Sales Development Executive ',
    ouName: 'Sales',
  },
  {
    id: '1430859c-d1de-40d6-853a-6528ffb7a92d',
    userName: 'Daniela Martinez Crespo',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1659363282/Courses/grts88p42lxlu9xbql05.jpg',
    roleName: 'Sr. Instructional Designer',
    ouName: 'Operations',
  },
  {
    id: 'd8a60369-7513-4088-aea8-55d1f6399914',
    userName: 'Darryl Philbin',
    userAvatar: '',
    roleName: 'Free Trial Role',
    ouName: '',
  },
  {
    id: '941919ad-7bbd-4905-842b-b7cc06628d67',
    userName: 'darth vader',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'ROL DE PRUEBA',
    ouName: '',
  },
  {
    id: '0c9a09ee-af12-422c-8bbb-f2a603dd2a50',
    userName: 'David Carreon',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1624894369/Courses/uoi3zer4zluyhvnvcku2.jpg',
    roleName: 'Product Designer',
    ouName: 'Product',
  },
  {
    id: '7e31c166-1a4e-4e0a-9ef7-5b3e9b058fef',
    userName: 'David Lozano',
    userAvatar: '',
    roleName: 'ET',
    ouName: 'Oxxo Gas - Operaciones',
  },
  {
    id: 'e04cb704-2da0-44d5-b3e2-592adbe3a830',
    userName: 'dd 23771',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Prueba Diego',
  },
  {
    id: 'b7b9519c-301a-4cd3-835f-e6abbfdb6ae2',
    userName: 'dd dd',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Administracion',
  },
  {
    id: 'e8f5f384-0097-4bac-9c49-e2102b3f5a8b',
    userName: 'Diana Lagunas',
    userAvatar: '',
    roleName: 'Instructional Designer',
    ouName: 'Operations',
  },
  {
    id: '5e12790a-8925-45d8-806e-cf4b8e026761',
    userName: 'Diego 2377',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Prueba Diego',
  },
  {
    id: 'cdb291f2-e3d0-4c66-8305-e78e85ffee19',
    userName: 'Diego Velazquez',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1680646175/Courses/mikymcuhogxjxwwktz4g.jpg',
    roleName: 'Account Executive',
    ouName: 'Customer Success',
  },
  {
    id: 'b6e8559e-8b33-4504-b1ab-0c5d6a4fd090',
    userName: 'Diego Rojas 2377',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Account Executive',
    ouName: 'Customer Success',
  },
  {
    id: '34cd2c2e-d1e7-4e62-88a2-518be9fea4f9',
    userName: 'Diego Rojas',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Administracion',
  },
  {
    id: '2256437c-2aac-479b-b0ed-00406af5bb3d',
    userName: 'Diego Lanesan (colaborador)',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Software Engineer',
    ouName: 'Engineering',
  },
  {
    id: 'bae61868-f02c-40f3-8ff0-009af03f02a7',
    userName: 'Diego Lanesan (jefe)',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Software Engineer',
    ouName: 'Engineering',
  },
  {
    id: 'b0612fea-ae12-482d-b165-4dd541517011',
    userName: 'Diego11111 2377',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Prueba Diego',
  },
  {
    id: 'e8912897-9194-49dd-bf2a-30e91f4c7a47',
    userName: 'Diego Raul Rojas Camargo',
    userAvatar: '',
    roleName: 'Software Engineer',
    ouName: 'Engineering',
  },
  {
    id: '3866f1e5-ff9f-46fc-b79d-13a85b229156',
    userName: 'Diego Raul Rojas Camargo',
    userAvatar: '',
    roleName: 'GERENTE DE TI',
    ouName: 'TRANSFORMACION Y DIGITAL ACEROS',
  },
  {
    id: 'c26cbb4e-0351-41c6-98de-a04a5b7a1c18',
    userName: 'Diego Raul Rojas Camargo',
    userAvatar: '',
    roleName: 'GERENTE DE TI',
    ouName: 'TRANSFORMACION Y DIGITAL ACEROS',
  },
  {
    id: 'ac75f1b7-4822-4617-8777-0e41e9443a77',
    userName: 'DIego Rojas Test 111',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Administracion',
  },
  {
    id: 'aa4b3a30-61df-4fe3-81ae-979068596339',
    userName: 'Diego Test 222',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Administracion',
  },
  {
    id: 'e9579bed-5d25-4e6d-901b-ab4f2db86d59',
    userName: 'D test Test',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Administracion',
  },
  {
    id: '9c77571a-7c48-499b-9475-c7ee62cbce72',
    userName: 'Duvan Narvaez',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1702055438/Courses/udeon9hril77vx6j9oje.jpg',
    roleName: 'Software Engineer',
    ouName: 'Engineering',
  },
  {
    id: 'f809d774-adbf-4ad6-936a-a9b5105c2e24',
    userName: 'Dwight Schrute',
    userAvatar: '',
    roleName: 'Free Trial Role',
    ouName: '',
  },
  {
    id: '793c27d8-00b9-48cd-a268-f1bd25b4395a',
    userName: 'ecea in',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png',
    roleName: 'Free Trial Role',
    ouName: 'Administracion',
  },
  {
    id: '47aebc5f-d0f7-40c2-992a-8ec9d1cbc922',
    userName: 'Ecristal Do',
    userAvatar: '',
    roleName: 'ROL DE PRUEBA',
    ouName: 'PRUEBAS QA',
  },
  {
    id: 'e9cd5c46-c3b4-47c6-a8e1-15d2b2a32d80',
    userName: 'Eduardo Peña Jiménez',
    userAvatar:
      'https://res.cloudinary.com/lernit/image/upload/v1679415739/Courses/mfiwf9mjinlokj9leibn.jpg',
    roleName: 'Practicante',
    ouName: 'Product',
  },
];
